module.exports = "/assets/data/4546d9bc995aa9b95a699e34d9bf7d9f-RG2.data.json";